import React, { useState } from "react";
import { map } from "lodash";
import SimpleFileRow from "../../../../shared/SimpleFileRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/pro-regular-svg-icons";
import { FileAttachment } from "../../../../../@types/activities";

type FileAttachmentsArgs = {
  files: FileAttachment[];
};

export default function FileAttachments({ files }: FileAttachmentsArgs) {
  const [showAllFiles, setShowAllFiles] = useState(false);

  const MAX_VISIBLE_FILES = 2;
  const shouldTruncate = files.length > 3;

  const visibleFiles =
    shouldTruncate && !showAllFiles ? files.slice(0, MAX_VISIBLE_FILES) : files;

  const remainingFilesCount = files.length - MAX_VISIBLE_FILES;

  function handleShowMore(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    setShowAllFiles(true);
  }

  return (
    <div>
      {map(visibleFiles, (file, index) => {
        if (!file.id) return null;

        return (
          <SimpleFileRow
            key={index}
            className="gap-1! px-0!"
            {...file}
            id={file.id}
            fileUrl={file.html_url}
            showMeta={false}
          />
        );
      })}

      {shouldTruncate && !showAllFiles && (
        <div className="flex gap-2 items-center mt-2">
          <FontAwesomeIcon
            className="text-muted ml-2"
            icon={faPaperclip}
            size="lg"
          />
          <button
            onClick={handleShowMore}
            className="text-primary hover:underline"
          >
            {I18n.t("js.activity.attachments.show_more_files", {
              file_count: remainingFilesCount,
            })}
          </button>
        </div>
      )}
    </div>
  );
}
